import {Fade, Slide} from "@mui/material";
import {TransitionProps} from "@mui/material/transitions";
import {ActionFormPopup} from "components/Admin/Pages/ActionFormPopup/ActionFormPopup";
import {useDeviceDetach} from "hooks/useDeviceDetach";
import React, {ReactNode, useMemo} from "react";
import {useTranslate} from "react-admin";

type CreatePopupProps<TProps, TResult> = {
  show?: boolean;
  onClose?: () => void;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  onSuccess?: (data: TResult) => void;
  queryKey?: string;
  label?: string;
  children?: ReactNode;
  createQuery: (props: { data: TProps }) => Promise<TResult>;
  zIndex?: number;
  defaultValue?: any;
  fullScreen?: boolean;
  TransitionComponent?: React.JSXElementConstructor<any>;
};

const SlideLeft = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const CreatePopup = <TProps, TResult extends { id: any }>(
  props: CreatePopupProps<TProps, TResult>
) => {
  const t = useTranslate();

  const {isMobile} = useDeviceDetach();

  const transitionComponent = useMemo(() => {
    if (props.TransitionComponent) {
      return props.TransitionComponent;
    }

    if (isMobile) {
      return SlideLeft;
    }

    return Fade;
  }, [isMobile, props.TransitionComponent]);

  return (
    <ActionFormPopup
      show={props.show}
      onClose={props.onClose}
      maxWidth={props.maxWidth}
      queryKey={props.queryKey}
      submitQuery={props.createQuery}
      onSuccess={props.onSuccess}
      label={props.label ?? t("ra.action.create")}
      submitButtonText={t("ra.action.create")}
      successMessage={t("ra.notification.created")}
      zIndex={props.zIndex ?? 200}
      defaultValue={props.defaultValue}
      TransitionComponent={transitionComponent}
      fullScreen={props.fullScreen}
      onSuccessNavigate={"."}
    >
      {props.children}
    </ActionFormPopup>
  );
};
